// Iterator function
export const countToTen = (num: 1 = 1) => {
	while (num <= 10) {
		console.log(num);
		num++;
	}
};

// Recursive Function
export const recurToTen = (num = 1) => {
	if (num > 10) return;
	console.log(num);
	num++;
	recurToTen(num);
};

// Fiibonacci without recurring
export const fibonacciWithoutRecurring = (
	num: number,
	arr: Array<number> = [0, 1],
) => {
	while (num > 2) {
		const [nextToLast, last] = arr.slice(-2);
		arr.push(nextToLast! + last!);
		num -= 1;
	}
	return arr;
};

// Fiibonacci with Recursion:
export const fibonacciWithRecurring = (
	num: number,
	array: Array<number> = [0, 1],
) => {
	if (num <= 2) return array;
	const [nextToLast, last] = array.slice(-2);
	return fibonacciWithRecurring(num - 1, [...array, nextToLast! + last!]);
};

// 4 * factorial(4)
// 3 * factorial(2)
// 2 * factorial(1)
export function RecursiveFactorial(n: number): number {
	if (n === 1 || n === 0) {
		return 1;
	} else {
		return n * RecursiveFactorial(n - 1);
	}
}
